export const AUTH_ENDPOINTS = {
  login: "/api/Auth/Login",
  verifyOtp: "/api/Auth/VerifyOtp",
  getUserDetails: "/api/Auth/GetUserDetails",
  updateUser: "/api/Auth/UpdateUser",
  deleteAccount: "/api/Auth/DeleteAccount",
};
